import React, { useEffect, useState } from "react";
import { fetchCallsPerDateAPI } from "../../../services/call";
import BarChart from "../../../components/BarChart";
import Loader from "../../../components/Loader";

const Calls = ({ startDate, endDate, selectedAssistant }) => {
  const [chartLabels, setChartLabels] = useState([]);
  const [callsData, setCallsData] = useState([]);
  const [minutesData, setMinutesData] = useState([]);
  const [spentData, setSpentData] = useState([]);
  const [avgCostData, setAvgCostData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totals, setTotals] = useState({ calls: 0, minutes: 0, spent: 0, avgcost: 0 });

  const [callEndReasonData, setCallEndReasonData] = useState([]);
  const [callEndReasonDataEnd, setCallEndReasonDataEnd] = useState([]);
  const [callStatusData, setCallStatusData] = useState([]);

  const fetchCallsPerDate = async (postData) => {
    setIsLoading(true);
    try {
      const responseData = await fetchCallsPerDateAPI(postData);
      if (responseData.status === "success") {
        const data = responseData.data.calls;

        const labels = data.map((item) => item.date);
        const calls = data.map((item) => item.calls || 0);
        const minutes = data.map((item) => item.total_minutes || 0);
        const spent = data.map((item) => item.total_spent || 0);
        const avgCost = data.map((item) => item.avg_cost || 0);

        setChartLabels(labels);
        setCallsData(calls);
        setMinutesData(minutes);
        setSpentData(spent);
        setAvgCostData(avgCost);

        setTotals({
          calls: calls.reduce((a, b) => a + b, 0),
          minutes: minutes.reduce((a, b) => a + b, 0),
          spent: spent.reduce((a, b) => a + b, 0),
          avgcost: avgCost ? avgCost.reduce((a, b) => a + b, 0) / avgCost.length : 0,
        });

        setCallEndReasonData(responseData.data.callsReasons);
        setCallEndReasonDataEnd(responseData.data.callsEndReasons);
        setCallStatusData(responseData.data.callsStatusData);
      }
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!startDate || !endDate) return;

    const startDateISO = startDate.toISOString().split("T")[0];
    const endDateISO = endDate.toISOString().split("T")[0];

    const postData = {
      startDate: startDateISO,
      endDate: endDateISO,
      assistant_id: selectedAssistant || "",
    };

    fetchCallsPerDate(postData);
  }, [startDate, endDate, selectedAssistant]);

  if (isLoading) return <Loader />;
  if (error) return <div>Error: {error?.message}</div>;

  return (
    <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-4">
      <div className="inline-block px-3 py-3 rounded-md border border-gray-800">
        <div className="relative py-3 text-left text-lg text-slate-400">
          Number of Calls
          <span className="absolute right-0 text-white text-[30px]">{totals.calls}</span>
        </div>
        {chartLabels && callsData.length > 0 && (
          <BarChart chartLabels={chartLabels} chartData={callsData} />
        )}
      </div>

      <div className="inline-block px-3 py-3 rounded-md border border-gray-800">
        <div className="relative py-3 text-left text-lg text-slate-400">
          Total Call Minutes
          <span className="absolute right-0 text-white text-[30px]">{totals.minutes}</span>
        </div>
        {chartLabels && minutesData.length > 0 && (
          <BarChart chartLabels={chartLabels} chartData={minutesData} />
        )}
      </div>

      <div className="inline-block px-3 py-3 rounded-md border border-gray-800">
        <div className="relative py-3 text-left text-lg text-slate-400">
          Total Spent
          <span className="absolute right-0 text-white text-[30px]">${parseFloat(totals.spent).toFixed(2)}</span>
        </div>
        {chartLabels && spentData.length > 0 && (
          <BarChart chartLabels={chartLabels} chartData={spentData} />
        )}
      </div>

      <div className="inline-block px-3 py-3 rounded-md border border-gray-800">
        <div className="relative py-3 text-left text-lg text-slate-400">
          Average Cost per Call
          <span className="absolute right-0 text-white text-[30px]">${parseFloat(totals.avgcost).toFixed(2)}</span>
        </div>
        {chartLabels && avgCostData.length > 0 && (
          <BarChart chartLabels={chartLabels} chartData={avgCostData} />
        )}
      </div>


      { /* Second row */}
      <div className="inline-block px-3 py-3 rounded-md border border-gray-800">
        <div className="relative py-3 text-left text-lg text-slate-400">
          Reason Call Ended
        </div>
        {chartLabels && callEndReasonData.length > 0 && (
          <BarChart chartLabels={chartLabels} customData={callEndReasonData} />
        )}
      </div>
      <div className="inline-block px-3 py-3 rounded-md border border-gray-800">
        <div className="relative py-3 text-left text-lg text-slate-400">
          Call Analysis
        </div>
        {chartLabels && callEndReasonDataEnd.length > 0 && (
          <BarChart chartLabels={chartLabels} customData={callEndReasonDataEnd} />
        )}
      </div>
      <div className="inline-block px-3 py-3 rounded-md border border-gray-800">
        <div className="relative py-3 text-left text-lg text-slate-400">
          Call Status
        </div>
        {chartLabels && callStatusData.length > 0 && (
          <BarChart chartLabels={chartLabels} customData={callStatusData} />
        )}
      </div>
    </div>
  );
};

export default Calls;